export const THEME_MAP = {
  2: 'storefront-drop-02',
  3: 'storefront-drop-03',
  4: 'storefront-drop-04',
  5: 'storefront-drop-07',
  6: 'storefront-drop-09',
  8: 'x-storefront-drop-01',
  9: 'x-storefront-drop-02',
  10: 'x-storefront-drop-06',
  11: 'x-storefront-drop-04',
  12: 'x-storefront-drop-05',
  13: 'x-storefront-drop-07',
  15: 'x-storefront-drop-15',
  16: 'x-storefront-drop-16',
  17: 'x-storefront-drop-17',
  19: 'x-storefront-mini',
  24: 'x-storefront-drop-24',
  25: 'x-storefront-mini-01',
  26: 'x-storefront-drop-20',
  27: 'x-storefront-mini-02',
  28: 'x-storefront-drop-19',
  29: 'x-storefront-drop-21',
  30: 'x-storefront-drop-22',
  31: 'x-storefront-drop-23',
  32: 'x-storefront-mini-03',
  33: 'x-storefront-mini-04',
  34: 'x-storefront-drop-27',
  35: 'x-storefront-drop-26',
  36: 'x-storefront-drop-28',
  37: 'x-storefront-drop-30',
  38: 'x-nuxt-38',
  39: 'x-storefront-drop-31',
  40: 'x-storefront-drop-32',
  41: 'x-storefront-drop-33',
  42: 'x-svelte-storefront-42',
  43: 'x-storefront-drop-36',
  44: 'x-storefront-drop-37',
  45: 'x-storefront-drop-45',
  46: 'x-storefront-drop-46',
  47: 'x-storefront-drop-47',
  48: 'x-storefront-drop-48',
  49: 'x-storefront-drop-49',
  50: 'x-storefront-mini-gmc',
  51: 'x-storefront-drop-51',
  52: 'x-storefront-drop-52',
  53: 'x-storefront-drop-53',
  54: 'x-storefront-mini-gmc-02',
  99: 'x-storefront-drop-99',
  100: 'x-storefront-drop-100',
  101: 'x-storefront-pod-01',
  102: 'storefront-newchic',
  103: 'x-storefront-pod-02',
  104: 'x-storefront-pod-03',
  105: 'x-storefront-pod-fashion',
  106: 'x-storefront-pod-04',
};

export function getThemeByValue(value) {
  const key = Number(value);
  return THEME_MAP[key] || '';
}

export const ALL_THEMES = [
  {
    name: 'DN-01',
    image: '/admin/img/themes/08.png',
    value: 8,
    type: 'dropship',
    theme: THEME_MAP[8],
  },
  {
    name: 'DN-02',
    image: 'https://cdn.latteprint.com/latte/2026-04-24/1777015943144-page2.png',
    value: 10,
    type: 'dropship',
    theme: THEME_MAP[10],
  },
  // {
  //   name: 'Blue Orange',
  //   image: 'https://cdn.latteprint.com/fulfillment/2025-08-01/1754041444959-2.png',
  //   value: 9,
  //   type: 'dropship',
  // },
  // {
  //   name: 'Greenlife (Bundle)',
  //   image: '',
  //   value: 11,
  //   type: 'dropship',
  // },
  // {
  //   name: 'Redvelvet',
  //   image: 'https://cdn.latteprint.com/fulfillment/2025-08-01/1754042534274-pagegreenlife.jpg',
  //   value: 12,
  //   type: 'dropship',
  // },
  // {
  //   name: 'DN-03',
  //   image: 'https://cdn.latteprint.com/fulfillment/2025-08-01/1754039953949-bluethemedropnoxe.jpg',
  //   value: 13,
  //   type: 'dropship',
  // },
  // {
  //   name: 'Blue Theme v2 (Google)',
  //   image: 'https://cdn.latteprint.com/fulfillment/2025-08-01/1754039953949-bluethemedropnoxe.jpg',
  //   value: 34,
  //   type: 'dropship',
  // },
  {
    name: 'DN-04',
    image: '/admin/img/themes/1793867294775-dn04.dropnoxe.com.jpg',
    value: 38,
    type: 'dropship',
    theme: THEME_MAP[38],
  },
  // {
  //   name: 'Modern Flow',
  //   image: '',
  //   value: 16,
  //   type: 'dropship',
  // },
  // {
  //   name: 'Sleek Design',
  //   image: '',
  //   value: 17,
  //   type: 'dropship',
  // },
  // {
  //   name: 'AutoPrime theme',
  //   image: 'https://cdn.latteprint.com/fulfillment/2025-08-01/1754042184727-1.jpg',
  //   value: 26,
  //   type: 'dropship',
  // },
  {
    name: 'DN-05-Bundle',
    image: 'https://cdn.latteprint.com/fulfillment/2025-08-07/1754562643635-page.png',
    value: 52,
    // value: 29,
    type: 'dropship',
    theme: THEME_MAP[52],
  },
  // {
  //   name: 'Fast theme',
  //   image: '',
  //   value: 24,
  //   type: 'dropship',
  // },
  // {
  //   name: 'NovaCart (Google)',
  //   image: 'https://cdn.latteprint.com/fulfillment/2025-08-09/1754726989927-2.jpg',
  //   value: 31,
  //   type: 'dropship',
  // },
  // {
  //   name: 'Varda',
  //   image: '',
  //   value: 37,
  //   type: 'dropship',
  // },
  // {
  //   name: 'Oasis Theme',
  //   image: '',
  //   value: 40,
  //   type: 'dropship',
  // },
  {
    name: 'DN-06',
    image: '/admin/img/themes/1793867747459-dn06.jpg',
    value: 44,
    type: 'dropship',
    theme: THEME_MAP[44],
  },
  {
    name: 'DN-07-TitanBoxer',
    image: 'https://cdn.latteprint.com/latte/2026-04-24/1777018226205-page1.png',
    value: 45,
    type: 'dropship',
    theme: THEME_MAP[45],
  },
  {
    name: 'DN-08-legging/bra',
    image: '/admin/img/themes/1793868122257-dn08.jpg',
    value: 46,
    type: 'dropship',
    theme: THEME_MAP[46],
  },
  {
    name: 'DN-09-Legging',
    image: '/admin/img/themes/1793868528585-dn09.jpg',
    value: 47,
    type: 'dropship',
    theme: THEME_MAP[47],
  },
  {
    name: 'DN-10',
    image: '/admin/img/themes/1793871025729-dn10.jpg',
    value: 35,
    type: 'dropship',
    theme: THEME_MAP[35],
  },
  {
    name: 'DN-11',
    image: '/admin/img/themes/1793872511427-dn11.jpg',
    value: 49,
    type: 'dropship',
    theme: THEME_MAP[49],
  },
  {
    name: 'DN-12-Bundle',
    image: 'https://cdn.latteprint.com/latte/2026-05-07/1778142296058-page.png',
    value: 48,
    type: 'dropship',
    theme: THEME_MAP[48],
  },
  {
    name: 'DN-13-GMC',
    image: 'https://cdn.latteprint.com/latte/2026-05-15/1778828203885-page.png',
    value: 50,
    type: 'dropship',
    theme: THEME_MAP[50],
  },
  {
    name: 'DN-14',
    image: '/admin/img/themes/1793871025731-dn14.jpg',
    value: 17,
    type: 'dropship',
    theme: THEME_MAP[17],
  },
  {
    name: 'DN-15 (Stripe Subscription)',
    image: '/admin/img/themes/1793873758977-dn15.jpg',
    value: 51,
    type: 'dropship',
    theme: THEME_MAP[51],
  },
  {
    name: 'DN-16',
    image: '/admin/img/themes/1793871025717-dn16.jpg',
    value: 30,
    type: 'dropship',
    theme: THEME_MAP[30],
  },
  {
    name: 'DN-17 (Order extras)',
    image: 'https://cdn.latteprint.com/fulfillment/2025-08-07/1754562643635-page.png',
    value: 53,
    type: 'dropship',
    theme: THEME_MAP[53],
  },
  // {
  //   name: 'FB Pixel Theme',
  //   value: 99,
  //   type: 'dropship',
  // },
  {
    name: 'DN-11',
    image: 'https://cdn.latteprint.com/latte/2026-04-24/1777012802278-page.png',
    value: 101,
    type: 'pod',
    theme: THEME_MAP[101],
  },
  {
    name: 'DN-12',
    image: 'https://cdn.latteprint.com/latte/2026-04-24/1777003913191-2.png',
    value: 102,
    type: 'pod',
    theme: THEME_MAP[102],
  },
  {
    name: 'DN-13',
    image: 'https://cdn.latteprint.com/latte/2026-04-24/1777003913191-2.png',
    value: 105,
    type: 'pod',
    theme: THEME_MAP[105],
  },
  {
    name: 'DN-14',
    image: 'https://cdn.latteprint.com/latte/2026-04-24/1777003913173-1.png',
    value: 103,
    type: 'pod',
    theme: THEME_MAP[103],
  },
  {
    name: 'DN-15',
    image: 'https://cdn.latteprint.com/latte/2026-04-24/1777015163575-bedding-set-fix.jpg',
    value: 104,
    type: 'pod',
    theme: THEME_MAP[104],
  },
  {
    name: 'DN-16',
    image: 'https://cdn.latteprint.com/latte/2026-04-24/1777015893188-beddingsetnx-fix.jpg',
    value: 106,
    type: 'pod',
    theme: THEME_MAP[106],
  },
  {
    name: 'DN-17 (Order extras)',
    image: 'https://cdn.latteprint.com/fulfillment/2025-08-07/1754562643635-page.png',
    value: 53,
    type: 'pod',
    theme: THEME_MAP[53],
  },
  {
    name: 'DN-Test-Bundle',
    image: 'https://cdn.latteprint.com/fulfillment/2025-08-07/1754562643635-page.png',
    value: 99,
    type: 'dropship',
    theme: THEME_MAP[99],
  },
];
